(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seletor-fluxo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-seletor-fluxo')) {
    const GOTINHA = 'M12 2C8 8 4 10 4 14a8 8 0 0016 0c0-4-4-6-8-12z';
    const VAZIA = -0.1; // abaixo de zero o líquido fica escondido
    const semAnimacao = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    const proximoQuadro = () => new Promise((pronto) => requestAnimationFrame(() => pronto()));
    const quandoOcioso = (fn) =>
      'requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 800 }) : setTimeout(fn, 150);

    // Renderizador de seções do Horizon (o mesmo usado pelo filtro de preço)
    let modulosDoTema;
    const carregarTema = () =>
      (modulosDoTema ??= import('@theme/section-renderer')
        .then((m) => ({ sectionRenderer: m.sectionRenderer, morphSection: m.morphSection }))
        .catch(() => null));

    class HfSeletorFluxo extends HTMLElement {
      pedido = 0;
      preCarregou = false;

      connectedCallback() {
        this.trilha = this.querySelector('.hf-sel__trilha');
        this.niveis = [...this.querySelectorAll('.hf-sel__nivel')];
        this.gota = this.querySelector('.hf-sel__gota');
        this.liquido = this.querySelector('.hf-sel__liquido');
        this.linha = this.querySelector('.hf-sel__linha-cheia');
        this.desc = this.querySelector('.hf-sel__desc');
        this.ativo = this.niveis.findIndex((n) => n.classList.contains('is-marcado'));
        this.visual = this.ativo;

        // Ao abrir a página, a gota enche do zero até o nível atual
        if (this.ativo >= 0 && !semAnimacao()) {
          this.liquido.style.transition = this.linha.style.transition = 'none';
          this.gota.style.setProperty('--nivel', VAZIA);
          this.trilha.style.setProperty('--p', 0);
          getComputedStyle(this.liquido).transform;
          getComputedStyle(this.linha).transform;
          this.liquido.style.transition = this.linha.style.transition = '';
          requestAnimationFrame(() => requestAnimationFrame(() => this.mostrar(this.ativo)));
        }

        this.trilha.addEventListener('pointerdown', this.aoPressionar);
        this.trilha.addEventListener('click', this.aoClicar);
        this.addEventListener('pointerenter', this.aoMostrarInteresse);
        this.addEventListener('focusin', this.aoMostrarInteresse);
        window.addEventListener('popstate', this.aoMudarHistorico);
        window.addEventListener('pageshow', this.aoMudarHistorico);
        carregarTema();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.aoMudarHistorico);
        window.removeEventListener('pageshow', this.aoMudarHistorico);
      }

      get secaoDosProdutos() {
        return document.querySelector('results-list[section-id]')?.getAttribute('section-id');
      }

      mostrar(i) {
        const nivel = this.niveis[i];
        this.visual = i;
        this.gota.style.setProperty('--nivel', nivel ? Number(nivel.dataset.fill) : VAZIA);
        this.trilha.style.setProperty('--p', nivel ? i / (this.niveis.length - 1) : 0);
        this.niveis.forEach((n, k) => {
          n.classList.toggle('is-marcado', k === i);
          n.classList.toggle('is-antes', i >= 0 && k < i);
          if (k === i) n.setAttribute('aria-current', 'page');
          else n.removeAttribute('aria-current');
        });

        this.desc.replaceChildren();
        if (!nivel) return;
        const gotas = document.createElement('span');
        gotas.className = 'hf-sel__gotinhas';
        gotas.setAttribute('aria-hidden', 'true');
        for (let g = 1; g <= 5; g++) {
          gotas.insertAdjacentHTML(
            'beforeend',
            `<svg viewBox="0 0 24 24"${g <= Number(nivel.dataset.gotas) ? ' class="is-cheia"' : ''}><path d="${GOTINHA}"/></svg>`
          );
        }
        const nome = document.createElement('strong');
        nome.textContent = nivel.dataset.nome;
        const texto = document.createElement('span');
        texto.textContent = nivel.dataset.desc;
        this.desc.append(gotas, nome, texto);
      }

      pular() {
        if (semAnimacao() || !this.gota.animate) return;
        this.gota.animate(
          [
            { transform: 'scale(1)' },
            { transform: 'scale(1.07, 0.95)', offset: 0.35 },
            { transform: 'scale(0.98, 1.03)', offset: 0.7 },
            { transform: 'scale(1)' },
          ],
          { duration: 550, easing: 'ease-out' }
        );
      }

      indiceEm(x) {
        const r = this.trilha.getBoundingClientRect();
        const i = Math.floor(((x - r.left) / r.width) * this.niveis.length);
        return Math.min(this.niveis.length - 1, Math.max(0, i));
      }

      // Endereço do nível mantendo os outros filtros (preço, ordenação); -1 = coleção inteira
      urlDoNivel(i) {
        const url = new URL(i >= 0 ? this.niveis[i].href : this.dataset.base, location.origin);
        const atuais = new URLSearchParams(location.search);
        atuais.delete('page');
        atuais.delete('section_id');
        atuais.forEach((valor, chave) => url.searchParams.append(chave, valor));
        return url;
      }

      async preCarregar(i) {
        const secao = this.secaoDosProdutos;
        const tema = await carregarTema();
        if (secao && tema) tema.sectionRenderer.getSectionHTML(secao, true, this.urlDoNivel(i)).catch(() => {});
      }

      // Na primeira interação com o seletor, deixa todos os níveis carregados para a troca ser imediata
      aoMostrarInteresse = () => {
        if (this.preCarregou) return;
        this.preCarregou = true;
        const indices = [...this.niveis.keys(), -1].filter((i) => i !== this.ativo);
        indices.forEach((i, n) => setTimeout(() => quandoOcioso(() => this.preCarregar(i)), n * 150));
      };

      aoPressionar = (e) => {
        if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        const trilha = this.trilha;
        const x0 = e.clientX;
        let moveu = false;
        trilha.setPointerCapture(e.pointerId);
        this.classList.add('is-arrastando', 'is-tocado');
        this.aoMostrarInteresse();

        const mover = (ev) => {
          if (Math.abs(ev.clientX - x0) > 6) moveu = true;
          const i = this.indiceEm(ev.clientX);
          if (i === this.visual) return;
          this.mostrar(i);
          this.pular();
          if (i !== this.ativo) this.preCarregar(i);
          if (ev !== e) navigator.vibrate?.(8);
        };
        const soltar = (ev) => {
          trilha.removeEventListener('pointermove', mover);
          trilha.removeEventListener('pointerup', soltar);
          trilha.removeEventListener('pointercancel', soltar);
          this.classList.remove('is-arrastando');
          if (ev.type === 'pointercancel') return this.mostrar(this.ativo);
          this.confirmar(this.visual, !moveu);
        };

        trilha.addEventListener('pointermove', mover);
        trilha.addEventListener('pointerup', soltar);
        trilha.addEventListener('pointercancel', soltar);
        mover(e);
      };

      aoClicar = (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return; // abrir em nova aba continua funcionando
        e.preventDefault();
        if (e.detail !== 0) return; // clique/toque já tratado no pointerup
        const nivel = e.target.closest('.hf-sel__nivel');
        if (!nivel) return;
        const i = this.niveis.indexOf(nivel);
        this.mostrar(i);
        this.pular();
        this.confirmar(i, true);
      };

      confirmar(i, foiToque) {
        if (i === this.ativo) {
          if (!foiToque) return; // arrastou e voltou para o nível em que já estava
          i = -1; // tocar no nível marcado volta para a coleção inteira
          this.mostrar(-1);
        }
        this.ativo = i;
        const url = this.urlDoNivel(i);
        history.pushState({ hfFluxo: true }, '', url);
        this.trocarProdutos(url.toString());
      }

      // Busca a lista nova sem congelar a tela e só troca quando ela chega.
      // (A transição de página do tema pausava a renderização durante o carregamento e travava a gota.)
      async trocarProdutos(url) {
        const pedido = ++this.pedido;
        const secao = this.secaoDosProdutos;
        const tema = await carregarTema();
        if (!secao || !tema) return location.assign(url);

        document.querySelector('results-list[section-id]')?.classList.add('hf-carregando');
        try {
          const html = await tema.sectionRenderer.getSectionHTML(secao, true, new URL(url, location.origin));
          if (pedido !== this.pedido) return; // já escolheram outro nível
          await proximoQuadro();
          if (pedido !== this.pedido) return;
          await tema.morphSection(secao, html);
        } catch {
          if (pedido === this.pedido) location.assign(url); // se der erro, carrega a página do jeito normal
        } finally {
          if (pedido === this.pedido) {
            document.querySelector('results-list[section-id]')?.classList.remove('hf-carregando');
          }
        }
      }

      // Botão voltar/avançar do navegador: acompanha o endereço
      aoMudarHistorico = (e) => {
        if (e.type === 'pageshow' && !e.persisted) return;
        const i = this.niveis.findIndex((n) => new URL(n.href).pathname === location.pathname);
        if (i === this.ativo) return this.mostrar(i);
        this.ativo = i;
        this.mostrar(i);
        if (e.type === 'pageshow') return;
        this.trocarProdutos(location.href);
      };
    }

    customElements.define('hf-seletor-fluxo', HfSeletorFluxo);
  }

  } catch(e) { console.error(e); }
})();
})();
